import React from 'react';
import LoadingIndicator from "../../components/common/loading/LoadingIndicator";
import './SpinnerModal.css'

export function SpinnerModal(props) {
  if (!props.visible){
    return null;
  }
  return (
      props.visible && <div className="spinner-modal" >
        <LoadingIndicator/>
      </div>
  );
}
